



































import { Component, Vue } from "vue-property-decorator";
import ConstructionList from "../components/ConstructionList.vue";
import { Construction, getConstruction } from "../../api/construction-api";
import { ServiceTaskType } from "@/servicetask/api/service-tasks-api";
export interface IConstructionListItem {
  construction: {
    serviceTaskTypeId: string;
    name: string;
    shortName: string;
  };
}

@Component({
  components: {
    ConstructionList
  }
})
export default class ConstructionListPage extends Vue {
  construction: Construction[] = [];
  fields = [
    { key: "name", label: "工事名", sortable: true },
    { key: "shortName", label: "工事名短縮", sortable: true },
    { key: "serviceTaskType", label: "工程表名", sortable: true }
  ];

  get templateOptions() {
    return this.$store.state.serviceTaskTypes.reduce(
      (m: Record<string, string>, t: ServiceTaskType) => {
        m[String(t.id)] = t.name;
        return m;
      },
      {}
    );
  }

  public created() {
    this.loadConstructionList();
  }

  private async loadConstructionList() {
    this.construction = await getConstruction();
  }

  create() {
    this.$router.push({ name: "construction-new" });
  }
}
